// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login.css */

.main-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  gap: 100px;
}

.logo-container {
  max-width: 300px;
  padding: 20px;
  text-align: center;
}

.logo {
  width: 100%;
  max-width: 250px;
  height: auto;
}

.password-input-container {
  position: relative;
}

.password-input {
  width: 100%;
  border-radius: 5px;
  position: relative;
}

.password-toggle-btn {
  position: absolute;
  right: 20px; /* Adjust as needed */
  top: 50%;
  transform: translateY(-50%);
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 5px;
  outline: none;
  font-size: 16px;
}

.password-toggle-btn:hover {
  color: #007bff; /* Change color on hover as desired */
}

.login-container {
  width: 100%;
  max-width: 400px;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.login-title {
  text-align: center;
  margin-bottom: 20px;
  font-size: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input {
  width: calc(100% - 22px); /* Adjust for padding and icon width */
  padding-right: 40px; /* Space for the eye icon */
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  transition: border-color 0.3s ease;
}

.form-group input:focus {
  border-color: #007bff;
}

.submit-btn {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 5px;
  background-color: #4cbb71;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.submit-btn:hover {
  border-color: #5780f3;
}

.loading-text {
  text-align: center;
  margin-top: 10px;
  font-style: italic;
}

.response {
  margin-top: 20px;
  text-align: center;
}
/* OTP Input Styling */
.otp-container {
  margin-top: 20px;
}

.otp-container label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
}

.otp-container input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  text-align: center;
}

.otp-container input:focus {
  border-color: #007bff;
  outline: none;
}

.otp-container .submit-btn {
  margin-top: 10px;
  background-color: #007bff;
  color: white;
  font-weight: bold;
}

.otp-container .submit-btn:hover {
  background-color: #0056b3;
}

/* Media query for screens up to 768px */
@media screen and (max-width: 768px) {
  .main-container {
    flex-direction: column;
    gap: 20px;
  }

  .logo-container {
    max-width: 250px;
  }

  .login-container {
    max-width: 300px;
  }

  .form-group input {
    width: calc(100% - 20px); /* Adjust for padding */
  }

  .submit-btn {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/FrontEnd/login/Login.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,qBAAqB;EAClC,QAAQ;EACR,2BAA2B;EAC3B,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc,EAAE,qCAAqC;AACvD;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,wBAAwB,EAAE,sCAAsC;EAChE,mBAAmB,EAAE,2BAA2B;EAChD,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA,sBAAsB;AACtB;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,wBAAwB,EAAE,uBAAuB;EACnD;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Login.css */\n\n.main-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  gap: 100px;\n}\n\n.logo-container {\n  max-width: 300px;\n  padding: 20px;\n  text-align: center;\n}\n\n.logo {\n  width: 100%;\n  max-width: 250px;\n  height: auto;\n}\n\n.password-input-container {\n  position: relative;\n}\n\n.password-input {\n  width: 100%;\n  border-radius: 5px;\n  position: relative;\n}\n\n.password-toggle-btn {\n  position: absolute;\n  right: 20px; /* Adjust as needed */\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 5px;\n  outline: none;\n  font-size: 16px;\n}\n\n.password-toggle-btn:hover {\n  color: #007bff; /* Change color on hover as desired */\n}\n\n.login-container {\n  width: 100%;\n  max-width: 400px;\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  background-color: #fff;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.login-title {\n  text-align: center;\n  margin-bottom: 20px;\n  font-size: 24px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.form-group input {\n  width: calc(100% - 22px); /* Adjust for padding and icon width */\n  padding-right: 40px; /* Space for the eye icon */\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  transition: border-color 0.3s ease;\n}\n\n.form-group input:focus {\n  border-color: #007bff;\n}\n\n.submit-btn {\n  width: 100%;\n  padding: 12px;\n  border: none;\n  border-radius: 5px;\n  background-color: #4cbb71;\n  color: #fff;\n  font-size: 18px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.submit-btn:hover {\n  border-color: #5780f3;\n}\n\n.loading-text {\n  text-align: center;\n  margin-top: 10px;\n  font-style: italic;\n}\n\n.response {\n  margin-top: 20px;\n  text-align: center;\n}\n/* OTP Input Styling */\n.otp-container {\n  margin-top: 20px;\n}\n\n.otp-container label {\n  display: block;\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n\n.otp-container input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n  text-align: center;\n}\n\n.otp-container input:focus {\n  border-color: #007bff;\n  outline: none;\n}\n\n.otp-container .submit-btn {\n  margin-top: 10px;\n  background-color: #007bff;\n  color: white;\n  font-weight: bold;\n}\n\n.otp-container .submit-btn:hover {\n  background-color: #0056b3;\n}\n\n/* Media query for screens up to 768px */\n@media screen and (max-width: 768px) {\n  .main-container {\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .logo-container {\n    max-width: 250px;\n  }\n\n  .login-container {\n    max-width: 300px;\n  }\n\n  .form-group input {\n    width: calc(100% - 20px); /* Adjust for padding */\n  }\n\n  .submit-btn {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
